export default {
  setAccessToken(accessToken) {
    localStorage.setItem("token", accessToken);
  },
  getAccessToken() {
    return localStorage.getItem("token");
  },
  logout() {
    localStorage.removeItem("token");
  },
  isLoggedIn() {
    return this.getAccessToken() != null && this.getAccessToken() != undefined;
  }
};
